import { ReducedManagerType } from "../../types/commonTypes/reducedManagerType";
import { initialReducedIndividualState } from "./initialReducedIndividualState";

export const initialReducedManagerState: ReducedManagerType = {
    person: "Personne physique",
    personDetails: initialReducedIndividualState
}